// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import CommentEditScreen from "../../../src/screens/comments/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} CommentEditRouteProps */

/** @typedef {Record<string, never>} CommentEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<CommentEditRouteProps, CommentEditRouteState>}
 */
class CommentEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit comment")}</ScreenTitle>
        <CommentEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<CommentEditRouteProps>} */
const CommentEditRouteComponent = memo(shapeComponent(CommentEditRoute))

export default CommentEditRouteComponent
